export default __webpack_public_path__ + "static/media/defaultBack.01f26e40.png";